var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlinedright(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 11.5L9.94444 14.6111L16.5556 7.22222M1 11.5C1 12.8789 1.27159 14.2443 1.79926 15.5182C2.32694 16.7921 3.10036 17.9496 4.07538 18.9246C5.0504 19.8996 6.20791 20.6731 7.48182 21.2007C8.75574 21.7284 10.1211 22 11.5 22C12.8789 22 14.2443 21.7284 15.5182 21.2007C16.7921 20.6731 17.9496 19.8996 18.9246 18.9246C19.8996 17.9496 20.6731 16.7921 21.2007 15.5182C21.7284 14.2443 22 12.8789 22 11.5C22 10.1211 21.7284 8.75574 21.2007 7.48182C20.6731 6.20791 19.8996 5.0504 18.9246 4.07538C17.9496 3.10036 16.7921 2.32694 15.5182 1.79926C14.2443 1.27159 12.8789 1 11.5 1C10.1211 1 8.75574 1.27159 7.48182 1.79926C6.20791 2.32694 5.0504 3.10036 4.07538 4.07538C3.10036 5.0504 2.32694 6.20791 1.79926 7.48182C1.27159 8.75574 1 10.1211 1 11.5Z",
    stroke: "#FF6000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedright);
export default __webpack_public_path__ + "static/media/outlinedright.dabf096d60222cba9d2ff1f476d0d8e0.svg";
export { ForwardRef as ReactComponent };